<template>
  <div class="avatar">
    <el-upload
      class="upload-demo"
      action=""
      :http-request="handleUpload"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :limit="1"
      :show-file-list="false"
      ref="uploadRef"
    >
      <el-tooltip
        popper-class="box-item"
        effect="light"
        :content="$t('profile.tips')"
        placement="right"
      >
        <div>
          <template v-if="avatarUrl">
            <div class="show">
              <img class="profile-bird" :src="avatarUrl" alt="" />
              <div class="uploadEN"></div>
            </div>
          </template>
          <template v-else>
            <div class="show">
              <img class="origin" alt="" />
              <div :class="$t('profile.upload')"></div>
            </div>
          </template></div
      ></el-tooltip>
    </el-upload>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { uploadAvatar } from '@/api/profile'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const { t } = useI18n()
    const uploadRef = ref()

    const handleSuccess = () => {
      uploadRef.value.clearFiles()
    }
    const handleUpload = async (options: any) => {
      const fd = new FormData()
      fd.append('file', options.file)
      const res = await uploadAvatar(fd)
      if (res.data) {
        emit('uploadSuccess')
      }
    }
    const beforeUpload = (file) => {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        ElMessage.error(t('profile.isLt2M'))
      }
      return isLt2M
    }

    return {
      handleUpload,
      beforeUpload,
      handleSuccess,
      uploadRef,
    }
  },
})
</script>
<style lang="less" scoped>
.avatar {
  text-align: center;
  margin-top: 30px;
  .profile-bird {
    width: 90px;
    height: 90px;
    border-radius: 100px;
    border: 3px solid #e5e5e5;
  }
  .uploadEN,
  .uploadCN {
    display: none;
    padding-top: 15px;
  }
  .show {
    position: relative;
  }
  .show .origin {
    width: 90px;
    height: 90px;
    content: url('../../common/image/profile/upload-bird.svg');
  }
  .show:hover .origin {
    width: 90px;
    height: 90px;
    content: url('../../common/image/profile/profile-bird.svg');
  }
  .show:hover .uploadEN {
    width: 90px;
    height: 90px;
    background: url('../../common/image/profile/upload-bird-en.svg') no-repeat;
    z-index: 10;
    position: absolute;
    display: inline-block;
    border-radius: 50%;
    left: 0px;
    top: 0px;
  }
  .show:hover .uploadCN {
    width: 90px;
    height: 90px;
    background: url('../../common/image/profile/upload-bird-cn.svg') no-repeat;
    z-index: 10;
    position: absolute;
    display: inline-block;
    border-radius: 50%;
    left: 0px;
    top: 0px;
  }
}
</style>
<style>
.box-item {
  margin-left: 10px;
  width: 250px;
  color: #9b9696;
}
</style>

